import { useState } from 'react';
import useFetch from '../../../../hooks/useFetch';
import { ServiceEvents } from '../../shared/interfaces';
import { buildEndpointIntranetCompany } from '../../EndPoints';
import { EventParticipation, defaultEventParticipation, EventParticipationFilters } from '../../../models/EventParticipation';

const useEventParticipationService = () => {
    const { doGet, doPost, doPut, doDelete } = useFetch();

    const [fetchingGetEventParticipationsByEvent, setFetchingGetEventParticipationsByEvent] = useState(false);


    const getEventParticipationsByEvent = (event_id: number, eventGuestFilters: EventParticipationFilters, events: ServiceEvents = {}) => {
        const queryString = Object.entries(eventGuestFilters)
            .map(([key, value]) => `${key}=${value}`)
            .join('&');

        doGet({
            ...events,
            type: 'company',
            url: `${buildEndpointIntranetCompany(`events/event-participations/${event_id.toString()}/by-event`)}?${queryString}`,
            setFetching: setFetchingGetEventParticipationsByEvent
        });
    };


    return {
        getEventParticipationsByEvent,
        fetchingGetEventParticipationsByEvent
    };
};

export default useEventParticipationService;
